import React from "react";

// Imports
import TitleText from "./TitleText";

const labsData = [
    {
    link: "labs/dr-lal-pathLabs",
    img: "/assets/drlal.svg",
  },
  {
    link: "labs/redcliffe-labs",
    img: "/assets/redcliffee.svg",
  },
  {
    link: "labs/agilus-diagnostics",
    img: "/assets/agilus.svg",
  },
  {
    link: "labs/pathkind-labs",
    img: "/assets/pathkind.svg",
  },
  {
    link: "labs/metropolis-healthcare",
    img: "/assets/metropolis.svg",
  }

];

const OurPartners = () => {
  return (
    <div className="w-full h-fit flex flex-col justify-start items-center space-y-[3%]">
      <TitleText text="Our Partners" />
      <div className="w-full h-fit flex flex-wrap justify-center items-center lg:space-x-5">
        {labsData?.map((lab, index) => (
          <img
            src={lab.img}
            alt="labs"
            key={index}
            loading="lazy"
            className="w-24 lg:w-32 h-24 lg:h-32 rounded-full shadow-xl object-cover mr-3 lg:mr-0 mb-3 lg:mb-0"
          />
        ))}
      </div>
    </div>
  );
};

export default OurPartners;
